import App from "@pages/App"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/")({
  component: App
})
